export class ModelPanier {
    idProduit: number = 0
    isVariation: boolean = false
    Quantite: number = 0
}